import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    turnIds: String
  }
  static targets = ["panel", "trigger"]

  async toggle() {
    const panel = this.panelTarget

    if (panel.style.display !== "none") {
      panel.style.display = "none"
      this.triggerTarget.textContent = this.triggerTarget.textContent.replace("收起", "查看证据")
      return
    }

    if (!panel.dataset.loaded) {
      panel.innerHTML = '<p style="color:#9ca3af;font-size:13px;padding:8px 12px;">加载中...</p>'
      panel.style.display = "block"

      try {
        const res = await fetch(`${this.urlValue}?turn_ids=${this.turnIdsValue}`)
        const data = await res.json()
        panel.innerHTML = this.renderEvidence(data)
        panel.dataset.loaded = "true"
      } catch (e) {
        panel.innerHTML = '<p style="color:#ef4444;font-size:13px;padding:8px 12px;">加载失败，请重试</p>'
      }
    } else {
      panel.style.display = "block"
    }

    this.triggerTarget.textContent = this.triggerTarget.textContent.replace("查看证据", "收起")
  }

  renderEvidence(items) {
    if (!items.length) return '<p style="color:#9ca3af;font-size:13px;padding:8px 12px;">暂无证据数据</p>'

    const sentimentEmoji = { positive: "😊", neutral: "😐", negative: "😠" }

    return items.map(item => {
      const emoji = sentimentEmoji[item.sentiment] || "😐"
      const labels = (item.labels || []).join(" · ")
      const summary = item.summary || "（无摘要）"

      return `
        <div style="padding:10px 12px;border-bottom:1px solid #f3f4f6;font-size:13px;">
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;">
            <span>${emoji}</span>
            <span style="color:#6b7280;font-size:12px;">${labels}</span>
          </div>
          <p style="margin:0;color:#374151;line-height:1.5;">${summary}</p>
        </div>
      `
    }).join("")
  }
}
